import { Component, h, Prop, Fragment, State, Host } from '@stencil/core';
import { DATA_VISUALIZATION_HUE, DATA_VISUALIZATION_HUE_VARIANT } from '../../constants';
import { getCssColorCode } from '../../utils/color-helper';

@Component({
  tag: 'uui-percent-bar-tooltip',
  styleUrl: 'uui-percent-bar-tooltip.scss',
  shadow: true
})
export class UUIPercentBarTooltip {
  @Prop() tooltipTitle?: string = '';
  @Prop() tooltipLabels?: string[];
  @Prop() segmentTotals: number[] = [];
  @Prop() segmentRanges: string[] = ['Not Scored', '0-25', '26-50', '51-75', '76-100'];
  @Prop() colors?: string[];
  @Prop() isShowSegmentTotalPercentage: boolean = true;
  @State() segmentPercents: number[];

  public aggregatedTotal: number = 0;
  public defaultColors = [
    DATA_VISUALIZATION_HUE_VARIANT.GRAY,
    DATA_VISUALIZATION_HUE_VARIANT.RED,
    DATA_VISUALIZATION_HUE_VARIANT.ORANGE,
    DATA_VISUALIZATION_HUE_VARIANT.YELLOW,
    DATA_VISUALIZATION_HUE_VARIANT.GREEN,
  ];

  componentWillLoad() {
    this.aggregatedTotal = (this.segmentTotals as number[]).reduce((acc, cur) => acc + cur, 0);
    this.computeSegmentPercents();
  }

  computeSegmentPercents() {
    this.segmentPercents = [];
    (this.segmentTotals as number[]).forEach((quantity) => {
      this.segmentPercents.push(
        Math.round(((quantity / this.aggregatedTotal) * 100) * 10) / 10,
      );
    });
  }

  getColor(index: number): string {
    if (this.colors && this.colors.length > index) {
      return getCssColorCode(this.colors[index]);
    }

    return DATA_VISUALIZATION_HUE[this.defaultColors[index]];
  };

  getTooltipRow(segmentTotal: number, rangeIndex: number): JSX.Element {
    if (segmentTotal === 0) {
      return;
    }

    const displayLabel = this.tooltipLabels && this.tooltipLabels[rangeIndex]
      ? this.tooltipLabels[rangeIndex]
      : segmentTotal;

    return (
      <Fragment>
        <span
          class="uui-percent-bar-tooltip-legend-dot uui-dv-legend-label"
          style={{
            backgroundColor: this.getColor(rangeIndex)
          }}
        ></span>

        <span class="uui-percent-bar-tooltip-range uui-dv-legend-label">
          {this.segmentRanges[rangeIndex]}
        </span>

        <span class="uui-percent-bar-tooltip-numeral uui-dv-legend-numeral">
          {this.isShowSegmentTotalPercentage
            ? `${Math.round(this.segmentPercents[rangeIndex])}%`
            : ''}
        </span>
        {this.isShowSegmentTotalPercentage && (
          <span class="uui-percent-bar-tooltip-numeral uui-dv-legend-numeral">|</span>
        )}
        <span class="uui-percent-bar-tooltip-numeral uui-dv-legend-numeral">
          {displayLabel}
        </span>
      </Fragment>
    );
  }

  getChartTooltip(): JSX.Element {
    return (
    <div class="uui-percent-bar-tooltip">
        <div class="uui-percent-bar-tooltip-column">
        <div class="uui-dv-legend-title">
            {this.tooltipTitle || 'Info'}
        </div>
        <div
            class="uui-percent-bar-tooltip-grid"
            style={{
            'grid-template-columns': this.isShowSegmentTotalPercentage
                ? `repeat(5, auto)`
                : `repeat(4, auto)`
            }}
        >
            {(this.segmentTotals as number[])
            .map((segmentTotal, rangeIndex) => this.getTooltipRow(segmentTotal, rangeIndex))}
        </div>
        </div>
    </div>
    );
  }

  render() {
    return (
      <Host>
        {this.getChartTooltip()}
      </Host>
    );
  }
}
